import React, { useState } from 'react';
import { injectIntl } from 'react-intl';
import { i18nIntl, isNotEmpty } from '../lib/ep';

import ActionLink from '../components/builder/ActionLink';
import WinnerLayer from '../components/prizes/WinnerLayer';
import EntriesButton from '../components/front/buttons/EntriesButton';
import VotemeButton from '../components/front/buttons/VotemeButton';
import BracketsButton from '../components/front/buttons/BracketsButton';
import GalleryButton from '../components/front/buttons/GalleryButton';
import ParticipateAgainButton from '../components/front/buttons/ParticipateAgainButton';
import ShareEntry from '../components/front/layers/ShareEntry';
import VotemeGalleryButton from '../components/front/buttons/VotemeGalleryButton';
import GoBackButton from '../components/front/buttons/GoBackButton';

const NORMAL_LOGIN_MODE = 1;
const AUTOLOGIN_MODE = 2;
const ANONYMOUS_MODE = 3;
const GUEST_MODE = 4;
const OPENID_MODE = 5;

const SuccessFinalButtons = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const promotion = props?.promotion?.Promotion ?? false;
	if(promotion === false) return null;
	const promotion_share_disabled = ((promotion?.config?.share?.status ?? '1') == '0') ? true : false;

	const promotion_premoderation_enabled = ((promotion?.confirm_to_publish ?? '0') == '1') ? true : false;

	const user = props?.user?.User ?? false;
	if(user === false) return null;

	const has_public_entries = (promotion.public_entries != undefined && promotion.public_entries != '0') ? true : false;

	const login_type = parseInt(promotion?.login_type ?? NORMAL_LOGIN_MODE);
	const login_id = props?.login_id ?? false;
	const login_data = props?.login_data ?? false;

	const display_my_participation = (login_id !== false && login_data !== false && login_type != ANONYMOUS_MODE) ? true : false;
	
	const display_brackets = promotion?.brackets_enabled ?? false;
	const prizes = props?.prizes ?? {};
	const total_prizes = prizes.length;

	const first_prize_popup = (prizes !== false && total_prizes == 1) ? (prizes[0]?.PrizeType?.popup_enabled ?? true) : false;
	const force_visible_on_load = props?.force_visible_on_load ?? true;
	const pre_display_prize = (first_prize_popup) ? force_visible_on_load : false;
	
	const [ display_prize_layer, setDisplayPrizeLayer ] = useState(pre_display_prize);
	const [ current_prize, setCurrentPrize ] = useState(0);

	const is_multiparticipation = promotion?.multi_participation ?? false;
	const display_back_button = promotion?.success_show_button_back ?? false;
	
	const navigateThroughPrizes = (direction) => {
		let _current_prize = current_prize;

		if(direction == 'next') {
			_current_prize++;
			if(_current_prize >= total_prizes) _current_prize = 0;
		}

		if(direction == 'prev') {
			_current_prize--;
			if(current_prize < 0) _current_prize = total_prizes - 1;
		}

		setCurrentPrize(_current_prize);
	};

	const openWinnerLayer = () => {
		setCurrentPrize(0);
		setDisplayPrizeLayer(true);
	};

	const has_prizes = (total_prizes > 0) ? true : false;
	const has_try_again = is_multiparticipation;
	const has_home_link = false;
	const has_voteme = ((user?.public_entry ?? '1') == '1') ? true : false;

	const gallery_link = (isNotEmpty(props, 'gallery_link')) ? props.gallery_link : false;
	if(!has_prizes && !has_try_again && !has_public_entries && !display_my_participation && !has_home_link && !display_brackets && !has_voteme && !gallery_link) {
		return null;
	}

	if(!has_prizes && login_type == ANONYMOUS_MODE) {
		return null;
	}

	const default_props = {
		promotion,
		in_widget:props.in_widget,
	};

	const stage = props?.stage?.Stage ?? false;
	const galleries = props?.galleries ?? [];
	const domain_url = window?.domain_url ?? (window?.common?.domain ?? window.location.hostname);
	const base_url = `https://${domain_url}/`;
	return (
		<>
			{(galleries.length > 0 && has_voteme && !promotion_share_disabled) && (
				<div class="gui_not_in_bottom_big">
					<ShareEntry
						user={user}
						share_data={galleries[0]?.share_data ?? {}}
						promotion={promotion}
						stage={stage}
						share_url={`${base_url}${galleries[0].url}`}
						sharing_type={(galleries[0].votable) ? 'gallery_voteme' : 'gallery_view'}
						type='button'
					/>
				</div>
			)}

			{(galleries.length == 0 && !promotion_premoderation_enabled && has_voteme && !promotion_share_disabled) && (
				<div class="gui_not_in_bottom_big">
					<ShareEntry
						user={user}
						share_data={props?.user_share_data ?? undefined}
						promotion={promotion}
						stage={stage}
						sharing_type = {"recruiting"}
						type='button'
					/>
				</div>
			)}

			<ul class="success_actions gui_main_text_color_on_bg">
				{(has_prizes) && (
					<li id={`p${prizes[current_prize].PrizeType.id}`} class="prizes_btn">
						<ActionLink
							onClick={() => openWinnerLayer()}
							icon='knk-winners'
							autotranslate={false}
						>{i18n("View prize")}: {prizes[current_prize].PrizeType.title}</ActionLink>
					</li>
				)}

				{(login_type != ANONYMOUS_MODE) && (
					<>
						{(has_try_again) && (
							<li class="enter_again_btn">
								<ParticipateAgainButton
									user={user}
									participations_info={props.participations_info}
									remaining_participations={props.remaining_participations}
									already={props.already}
									instant={props.instant}
									total_entries={props.total_entries}
									{...default_props}
								/>
							</li>
						)}

						{(has_public_entries) && (
							<li class="entries_btn">
								<EntriesButton
									{...default_props}
								/>
							</li>
						)}

						{(display_brackets) && (
							<li class="brackets_btn">
								<BracketsButton
									bracket_id={props.bracket_id}
									{...default_props}
								/>
							</li>
						)}

						{(gallery_link) && (
							<li class="gallery_btn">
								<GalleryButton
									icon="knk-template"
									link={gallery_link}
									{...default_props}
								/>
							</li>
						)}

						{(has_voteme && !is_multiparticipation) && (
							<li class="voteme_btn">
								<VotemeButton
									user={user}
									{...default_props}
								>View your entry</VotemeButton>
							</li>
						)}

						{(has_voteme && is_multiparticipation && galleries.length > 0) && (
							<li class="voteme_btn">
								{galleries.map((gallery,item)=> {
									let label_view_your_entry = i18n("View your entry");
									if(galleries.length > 1) label_view_your_entry += ` (${gallery.title})`;

									return (
										<li key={`gallery${gallery.id}`}>
											<VotemeGalleryButton
												link={`${base_url}${gallery.url}`}
												autotranslate={false}
												{...default_props}
											>{label_view_your_entry}</VotemeGalleryButton>
										</li>
									)
								})}
								
							</li>
						)}

						{(display_back_button) && (
							<li class="back_btn">
								<GoBackButton
									{...default_props}
								/>
							</li>
						)}

						{/*((!is_multiparticipation && has_home_link) || has_try_again) && (
							<li class="home_btn">
								<HomeButton
									{...default_props}
								/>
							</li>
						)*/}
					</>
				)}
			</ul>
			
			{(has_prizes && display_prize_layer) && (
				<WinnerLayer
					actual_prize={current_prize + 1}
					autoplay={true}
					backButton={() => setDisplayPrizeLayer(false)}
					code={prizes[current_prize].PromoCode}
					code_validation={prizes[current_prize]?.CodeValidation ?? null}
					promo_claim={prizes[current_prize]?.PromoClaim ?? null}
					disable_navigation={total_prizes == 1}
					layout_props={promotion.layout_props}
					navigate={(direction) => navigateThroughPrizes(direction)}
					next_prize={prizes[(current_prize < total_prizes - 1) ? current_prize + 1 : 0].PrizeType}
					prev_prize={prizes[(current_prize > 0) ? current_prize - 1 : total_prizes - 1].PrizeType}
					prize={prizes[current_prize].PrizeType}
					share={prizes[current_prize].Share}
					total_prizes={total_prizes}
					user_prize={prizes[current_prize].Prize}
					user={prizes[current_prize].User}
					validation_portal={promotion?.code_validator ?? null}
					//validation_portal={prizes.validation_portal}
				/>
			)}
		</>
	)
}

export default injectIntl(SuccessFinalButtons);